import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import About from "../pages/About/About";
import CategoryProduct from "../pages/CategoryProduct/CategoryProduct";
import CGV from "../pages/Cgv/Cgv";
import Commitment from "../pages/Commitment/Commitment";
import Contact from "../pages/Contact/Contact";
import EmailVerification from "../pages/EmailVerification/EmailVerification";
// import Contact from "../pages/Contact/Contact";
import Homepage from "../pages/Homepage/Home";
import Invoice from "../pages/Invoice/Invoice";
import Login from "../pages/Login/Login";
import Order from "../pages/Order/Order";
import Product from "../pages/Product/Product";
import Products from "../pages/Products/Products";
import Profile from "../pages/Profile/Profile";
import Purchase from "../pages/Purchase/Purchase";
import ResetPasswordConfirm from "../pages/ResetPassword/Confirm/ResetPasswordConfirm";
import ResetPasswordRequest from "../pages/ResetPassword/Request/ResetPasswordRequest";
// import { ProtectedRoute } from "./ProtectedRoute";
import { Navigate, useRoutes } from "react-router-dom";

const APP_ROUTES = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: (
      <>
        <Header />
        <Homepage />
        <Footer />
      </>
    ),
  },
  {
    path: "/about",
    element: (
      <>
        <Header />
        <About />
        <Footer />
      </>
    ),
  },
  {
    path: "/contact",
    element: (
      <>
        <Header />
        <Contact />
        <Footer />
      </>
    ),
  },
  {
    path: "/commitment",
    element: (
      <>
        <Header />
        <Commitment />
        <Footer />
      </>
    ),
  },
  {
    path: "/category-product",
    element: (
      <>
        <Header />
        <CategoryProduct />
        <Footer />
      </>
    ),
  },
  {
    path: "/category-product/:category",
    element: (
      <>
        <Header />
        <Products />
        <Footer />
      </>
    ),
  },
  {
    path: "/category-product/:category/:subcategory",
    element: (
      <>
        <Header />
        <Products />
        <Footer />
      </>
    ),
  },
  {
    path: "/category-product/:category/:subcategory/:idproduct",
    element: (
      <>
        <Header />
        <Product />
        <Footer />
      </>
    ),
  },
  {
    path: "/order",
    element: (
      <>
        <Header />
        <Order />
        <Footer />
      </>
    ),
  },
  {
    path: "/profile",
    element: (
      <>
        <Header />
        <Profile />
        <Footer />
      </>
    ),
  },
  {
    path: "/purchase",
    element: (
      <>
        <Header />
        <Purchase />
        <Footer />
      </>
    ),
  },
  {
    path: "/invoice/:orderId",
    element: (
      <>
        <Header />
        <Invoice />
        <Footer />
      </>
    ),
  },
  {
    path: "/verify-email",
    element: (
      <>
        <Header />
        <EmailVerification />
        <Footer />
      </>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <>
        <Header />
        <ResetPasswordRequest />
        <Footer />
      </>
    ),
  },
  {
    path: "/reset-password/confirm",
    element: (
      <>
        <Header />
        <ResetPasswordConfirm />
        <Footer />
      </>
    ),
  },
  {
    path: "/cgv",
    element: (
      <>
        <Header />
        <CGV />
        <Footer />
      </>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

const RoutesComponent = () => {
  const routes = useRoutes(APP_ROUTES);
  return routes;
};

export default RoutesComponent;
